module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sliders/slider-style2/slider-style2.component.scss
// module id = ./src/app/sliders/slider-style2/slider-style2.component.scss
// module chunks = main